/*
 * @Author: HS
 * @Date: 2022-02-14 15:49:30
 * @LastEditors: DQL
 * @LastEditTime: 2022-03-01 14:49:51
 * @Description: file content
 */
const jqpzRoutes = {
  path: 'jqpz',
  name: 'jqpz',
  component: () =>
    import(
      /* webpackChunkName:"jqpz" */ '@/features/attendance/jqpz/index.vue'
    ),
  meta: {
    navtabTitle: '年度假期配置',
    isCache: true,
    ignoreDiff: [],
    menuElements: []
  }
};
export default jqpzRoutes;
